export const css = {
	root: '_1wxj1N4l _36_XU7M5',
	loading: '_1-LX1TFJ',
	spin: 'FCJF0DyO',
	' _key': 'afcpe-theme/dojo/grid-placeholder-row'
};

export default css;
